export default "__VITE_ASSET__ldrp4nkm__"